import React from 'react';

import renderAutoSuggestWithOptions from 'app/employer/components/autoSuggest/AutoSuggestHOC';
import { companyAutoCompleteInput$, companyAutoCompleteObservable$ } from 'app/employer/redux/autosuggest/autoCompleteService';

const CompanyAutoSuggest = renderAutoSuggestWithOptions(
   companyAutoCompleteObservable$,
   companyAutoCompleteInput$,
);

CompanyAutoSuggest.defaultProps = {
   selected: {
      id: null,
      name: '',
   },
   filterOrganization: {
      id: null,
      name: '',
   },
   forceSelection: false,
   placeholder: 'Search Company...',
};

export default CompanyAutoSuggest;
